import api from "./api"

export const KWIKAPI_TOKEN            = '@kwikapi-token';
export const KWIKAPI_ADMIN_TOKEN      = '@kwikapi-admin-token';
export const KWIKAPI_SUPERADMIN_TOKEN = '@kwikapi-superadmin-token';
export const ASSISTANT_TAB_EXTERNAL_ID = '@assistant-tab-external-id';

export const SESSION = '';

export const isAuthenticated = localStorage.getItem(KWIKAPI_TOKEN) !== null;
export const isSuperAdminAuthenticated = localStorage.getItem(KWIKAPI_SUPERADMIN_TOKEN) !== null;

export const getToken           = () => localStorage.getItem(KWIKAPI_TOKEN);
export const getAdminToken      = () => localStorage.getItem(KWIKAPI_ADMIN_TOKEN);
export const getSuperAdminToken = () => localStorage.getItem(KWIKAPI_SUPERADMIN_TOKEN);

export const getSession = () => JSON.parse(localStorage.getItem(SESSION));

export const saveToken           = (token) => localStorage.setItem(KWIKAPI_TOKEN, token);
export const saveAdminToken      = (token) => localStorage.setItem(KWIKAPI_ADMIN_TOKEN, token);
export const saveSuperAdminToken = (token) => localStorage.setItem(KWIKAPI_SUPERADMIN_TOKEN, token);

export const saveSession = (session) => localStorage.setItem(SESSION, JSON.stringify(session));

export const clearSession    = () => localStorage.removeItem(SESSION);
export const clearToken      = () => localStorage.removeItem(KWIKAPI_TOKEN);
export const clearAdminToken = () => localStorage.removeItem(KWIKAPI_ADMIN_TOKEN);

// Stable id for the full-tab Cortex assistant conversation: kept for the
// whole login (survives tab switches/reloads via localStorage), only
// regenerated on the next login (see clearAssistantTabId, called on logout).
export const getOrCreateAssistantTabId = () => {
    let id = sessionStorage.getItem(ASSISTANT_TAB_EXTERNAL_ID);
    if (!id) {
        id = crypto.randomUUID();
        sessionStorage.setItem(ASSISTANT_TAB_EXTERNAL_ID, id);
    }
    return id;
};

export const clearAssistantTabId = () => sessionStorage.removeItem(ASSISTANT_TAB_EXTERNAL_ID);

export const finishLogin = async (data, setShowAlert, setLoading) => {

    const isSupport = data.user.groups.some(
        group => group.name === "suporte"
    );

    if (isSupport) {
        saveToken(data.access);
        saveSession(data.user);
        window.location.href = "/support/enterprise";
        return;
    }

    let agentId = null;
    try {
        agentId = data.user.profile.agent.id
    } catch (e) {
        if (e instanceof TypeError) {
            setShowAlert("error", "Não há operador relacionado à este usuário.")
            setLoading(false)
            return
        }
        throw e
    }
    if (! agentId) return
    
    // Only save token if user has an agent related
    saveToken(data.access)

    // Login related agent
    await api.post(`/api/IV/agents/${agentId}/login/`).then((res) => {
        if (res.status == 200 && res.data.agentstatus != 'LOGOFF') {
            // Replacing agent data with new status
            data.user.profile.agent = res.data
            saveSession(data.user)
            window.location.href = '/chat'
            return
        }
        throw res
    }).catch((err) => {
        console.error('Couldnt login agent [err:%o]', err)
        clearToken()
        clearSession()
        if ('data' in err && err.data[0] === 'Sua desgutação Kwik chegou ao fim.')
            setShowAlert("error", err.data)
        else
            setShowAlert("error", "Algo deu errado, tente novamente.")
        setLoading(false)
    })
}
